<template>
  <main class="page">
    <section class="section page__header">
      <h1 class="title">Контрагенты</h1>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item page__search">
            <SearchForm :value="searchValue"
                        @form-submit="setSearchValue"
            />
          </div>
          <AppButtonFilter
            :active="filterIsActive"
            @click.native="toggleFilter"
          />
        </div>
        <div class="table__buttons">
          <transition name="fade" v-if="roleAccessRemove">
              <AppButtonSmRemove
                v-if="isActiveDelete"
                title="Удалить"
                @click.stop.native="showRemoveConfirmationGroup"
                style="margin-right: 20px"
              />
          </transition>
          <AppButtonSmAdd v-if="roleAccessCreate" title="Создать"  @click.stop.native="goToContractorUpdate('create')" />
        </div>
      </div>

      <transition name="fade">
        <Form
          v-model="filterData"
          :value="filter"
          @request="setFilter"
          ref="filterForm"
          v-if="filterIsActive"
          class="filter"
        >
          <div class="filter__list">
            <AppSelect
              title="Статус"
              :options="statusOptionList"
              newItemFromSearch
              placeholder="Не выбрано"
              name="status"
            />
            <VInput name="contractorName" label="Краткое наименование" />
            <VInput name="contractorAddress" label="Юридический адрес" />
            <VInput name="contractorINN" label="ИНН" />
            <AppInputDate name="createDate" title="Дата создания" />
            <VInput name="contractorPerson" label="Контактное лицо" />
            <VInput name="contractorPosition" label="Должность" />
            <AppSelect
              title="Тип контрагента"
              :options="typeOptionList"
              newItemFromSearch
              placeholder="Не выбрано"
              name="contractorType"
            />

          </div>
          <div class="filter__buttons">
            <AppButton
              type="main"
              title="Показать"
            />
            <AppButton
              type="alt"
              title="Сбросить"
              @click.stop.native="clearFilter"
            />
          </div>
        </Form>
      </transition>

      <div class="page__table mb-20" v-if="contractors.length !== 0">
        <AppTable :data="contractors"
                  :headers="tableHeaders.headers"
                  :has-checkbox="roleAccessRemove"
                  :isMenuControlsActive=false
                  :all-items-active="tableHeaders.allActive"
                  @toggle-active-item="toggleActiveItem"
                  @toggle-active-all="toggleActiveAll"
                  @edit-this-item="goToContractorUpdate"
                  @show-this-item="goToContractorUpdate"
                  @remove-this-item="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20"  v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Записи не найдены"/>
        </div>
      </div>
    </section>

    <section class="section page__footer page__footer_has-pagination">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade" v-if="roleAccessRemove">
      <AppConfirmation v-if="removeConfirmation.active"
                       :text="removeConfirmation.group ? 'Вы действительно хотите удалить эти контрагенты?' : 'Вы действительно хотите удалить этого контрагента?'"
                       @confirm="removeConfirmation.group ? deleteContractorsChecked() : removeContractor()"
                       @reject="closeRemoveConfirmation"
      />
      <AppModal v-if="deleteResponseModal.isActive"
                :title="deleteResponseModal.title"
                :text="deleteResponseModal.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModal.type"
                @confirm="closeDeleteModal"
      />
    </transition>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>

import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppModal from '@/components/page/modal/AppModal'
import AppButtonFilter from '@/components/page/button/AppButtonFilter'
import AppSelect from '@/components/page/input/AppSelect'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import Form from '@/components/page/Form/Form'
import AppButton from '@/components/page/button/AppButton'
import AppInputDate from '@/components/page/input/AppInputDate'
import VPagination from '@/components/page/VPagination'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractorList',
  components: {
    AppModal,
    AppButtonSmRemove,
    ThePagePreloader,
    AppConfirmation,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    SearchForm,
    AppButtonFilter,
    AppSelect,
    VInput,
    Form,
    AppButton,
    AppInputDate,
    VPagination
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      },
      // фильтр
      filterIsActive: false,
      filterData: {}
    }
  },
  computed: {
    ...mapGetters('contractorListPage', [
      'getContractorsList',
      'getContractorsListActiveDelete',
      'getContractorsListFilter',
      'getContractorsListIsLoading',
      'getContractorsListPagination',
      'getContractorsListResponseModal',
      'getContractorsListSearchValue',
      'getContractorsListTableHeaders'
    ]),
    tableHeaders () {
      return this.getContractorsListTableHeaders
    },
    contractors () {
      return this.getContractorsList.map(contractor => {
        return ({
          id: contractor.id,
          isControlsActive: contractor.isControlsActive,
          isActive: contractor.isActive,
          values: [
            contractor.status?.name, contractor.short_name, contractor.legal_address, contractor.inn, contractor.created_at, contractor.contact_fullname, contractor.contact_position, contractor.type?.name
          ]
        })
      })
    },
    searchValue () {
      return this.getContractorsListSearchValue
    },
    filter () {
      return this.getContractorsListFilter
    },
    pagination () {
      return this.getContractorsListPagination
    },
    statusOptionList () {
      return this.$store.getters.getContractorStatusList
    },
    typeOptionList () {
      return this.$store.getters.getContractorTypeList
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    isLoading () {
      return this.getContractorsListIsLoading
    },
    deleteResponseModal () {
      return this.getContractorsListResponseModal
    },
    isActiveDelete () {
      return this.getContractorsListActiveDelete
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightContractors.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContractors.actions.remove
    }
  },
  methods: {
    goToContractorUpdate (id) {
      this.$router.push({ name: 'ContractorUpdate', params: { id } })
    },
    toggleItemControls (itemId) {
      this.$store.dispatch('contractorListPage/toggleContractorsListItemControls', itemId)
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('contractorListPage/toggleContractorsListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('contractorListPage/toggleContractorsListItemActiveAll')
    },
    showRemoveConfirmation (id) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
      this.removeConfirmation.group = false
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    removeContractor () {
      const itemId = this.removeConfirmation.id
      this.$store.dispatch('contractorListPage/removeContractorItem', itemId)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    deleteContractorsChecked () {
      this.removeConfirmation.active = false
      this.$store.dispatch('contractorListPage/deleteContractorsListCheckedItems')
    },
    closeDeleteModal () {
      this.$store.dispatch('contractorListPage/closeContractorsListDeleteModal')
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('contractorListPage/setContractorsListSearchValue', value)
    },

    // filter
    toggleFilter () {
      this.filterIsActive = !this.filterIsActive
    },
    setFilter (data) {
      console.log(data)
      const filter = {
        Status: data.status?.id,
        Name: data.contractorName,
        Address: data.contractorAddress,
        Inn: data.contractorINN,
        CreateDate: data.createDate,
        Person: data.contractorPerson,
        Position: data.contractorPosition,
        Type: data.contractorType?.id
      }
      this.$store.commit('contractorListPage/SET_CONTRACTOR_LIST_FILTER', filter)
      this.$store.dispatch('contractorListPage/getContractorsListPage', 1)
      this.$store.dispatch('contractorListPage/getContractors')
    },
    clearFilter () {
      this.$refs.filterForm.clear()
      this.$store.commit('contractorListPage/SET_CONTRACTOR_LIST_FILTER', {})
      this.$store.dispatch('contractorListPage/getContractors')
    },

    // pagination
    getPage (pageNum) {
      this.$store.dispatch('contractorListPage/getContractorsListPage', pageNum)
    }
  },
  mounted () {
    this.$store.dispatch('contractorListPage/getContractors')
    this.$store.dispatch('getContractorAllOptions')
  },

  destroyed () {
    this.$store.commit('contractorListPage/RESET_CONTRACTORS_LIST_STORE')
  }
}
</script>

<style lang="scss">
.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}
</style>
